import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators , FormControl } from '@angular/forms';
import {HttpClient, HttpResponse} from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ParametroAccionService } from 'src/app/Services/parametro-accion.service';

@Component({
  selector: 'app-rut-empresa-form',
  templateUrl: './rut-empresa-form.component.html',
  styleUrls: ['./rut-empresa-form.component.css']
})
export class RutEmpresaFormComponent implements OnInit {

  rut: string;
  form: FormGroup;
  private emprdet:string = environment.emprdet;

  constructor(private toastr: ToastrService,private fb: FormBuilder,private router: Router,private http: HttpClient, public parametroAccionService:ParametroAccionService) { 
    this.form = this.fb.group({
      rut: ['', Validators.required],
    });
  }
  


  ngOnInit(): void {
    
    document.addEventListener('input', (e) => {
      const rutInput = document.getElementById('rut') as HTMLInputElement;
    
      if (e.target === rutInput) {
        const rutLimpio = rutInput.value.replace(/[^0-9kK]/g, '');
    
        // aislar el cuerpo del dígito verificador
        const cuerpo = rutLimpio.slice(0, -1);
        const dv = rutLimpio.slice(-1).toUpperCase();
    
        if (rutLimpio.length < 2) return rutLimpio;
    
        // colocar los separadores de miles al cuerpo
        let cuerpoFormatoMiles = cuerpo
          .toString()
          .split('')
          .reverse()
          .join('')
          .replace(/(?=\d*\.?)(\d{3})/g, '$1.');
    
        cuerpoFormatoMiles = cuerpoFormatoMiles
          .split('')
          .reverse()
          .join('')
          .replace(/^[\.]/, '');
    
        const rutFormateado = `${cuerpoFormatoMiles}-${dv}`;
    
        rutInput.value = rutFormateado;
      }
    });
  }

  aceptar() {
    let httpost = this.http;
    let urltoken = `${ this.emprdet}`;
    this.rut=this.form.get('rut').value;
    //console.log('rut de empresa: '+this.rut);
    const cuerpo = this.rut.slice(0, -1);
    const dv = this.rut.slice(-1).toUpperCase();
    //console.log('separado:'+cuerpo);
    const cuerpo2 = Number(cuerpo.replace(/[^\d]/g, ''));
    //console.log('separado y sin puntos ni guion2:'+cuerpo2);
    httpost.post<any>(urltoken, { 
      rut_empresa:cuerpo2
    }, { observe: 'response' }).subscribe((response: HttpResponse<any>) => {
      const status = response.status;
      //console.log(response);
      const data = response.body;
      if (status===202) {
        const nuevosDatos = {
          rut: cuerpo2,
          dv: dv
        };
        console.log("rut:" +cuerpo2+" dv: "+dv);
        this.parametroAccionService.guardarParam('1');
        this.parametroAccionService.guardarDatos(nuevosDatos);
        this.toastr.info('Información', 'Empresa sin detalles.');
        this.router.navigate(['/empresa-form']);
      }else if (status===200) {
        //aqui se tiene que usar servicio para pasar los datos de empresa al formulario
        data.Consulta.forEach((item) => {
          const nuevosDatos = {
            rut: item.PRSH_CDG_PERS,
            dv: item.PRSH_DV_PERS,
            razonSocial: item.PRSH_RZN_SOCIAL,
            fechaIngreso: item.PRSH_FCH_INGRESO
          };
          this.parametroAccionService.guardarParam('1');
          this.parametroAccionService.guardarDatos(nuevosDatos);
        });
        this.toastr.info('Empresa encontrada.');
        this.router.navigate(['/represent-legal-form']);
      }else{
        console.log("error capturado al buscar detalle de empresa");
        this.toastr.error('Error', 'Al buscar empresa.');
      }
    }, err => {
      console.log("error capturado al buscar detalle de empresa");
      this.toastr.error('Error', 'Al buscar empresa.');
      console.log(err);
    });
    //this.rut=
  }
  
  // dar formato XX.XXX.XXX-X
  darFormatoRUT(rut) {
    // dejar solo números y letras 'k'
    const rutLimpio = rut.replace(/[^0-9kK]/g, '');
  
    // asilar el cuerpo del dígito verificador
    const cuerpo = rutLimpio.slice(0, -1);
    const dv = rutLimpio.slice(-1).toUpperCase();
  
    if (rutLimpio.length < 2) return rutLimpio;
  
    // colocar los separadores de miles al cuerpo
    let cuerpoFormatoMiles = cuerpo
      .toString()
      .split('')
      .reverse()
      .join('')
      .replace(/(?=\d*\.?)(\d{3})/g, '$1.'); 
  
    cuerpoFormatoMiles = cuerpoFormatoMiles
      .split('')
      .reverse()
      .join('')
      .replace(/^[\.]/, '');
  
    return `${cuerpoFormatoMiles}-${dv}`;
  }

}
